import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import { createItemCategorymaster, listItemCategorymaster } from '../../graphql';

export const itemCategory = createApi({
    reducerPath: 'itemCategoryApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        listItemCategorymaster: builder.query({
            query: (variables) => ({ body: listItemCategorymaster, variables }),
            keepUnusedDataFor: Infinity,
            refetchOnMountOrArgChange: true,
            providesTags: (result, error, { maincategory }) => [
                { type: "listVoucherSettings", id: maincategory },
            ],
        }),
        createItemCategorymaster: builder.mutation({
            query: (variables) => ({ body: createItemCategorymaster, variables }),
            invalidatesTags: (result, error, { maincategory }) => [
                { type: "listVoucherSettings", id: maincategory },
            ],
        }),

    }),
});

export const { useCreateItemCategorymasterMutation, useListItemCategorymasterQuery } = itemCategory;
